import {BaseButton} from "../core/Button";
import {Mix} from "../core/Reflection";
import {Focusable} from "./Focusable";

export class FocusableButton extends Mix(BaseButton, Focusable) {
}
